import { render, staticRenderFns } from "./pkg.vue?vue&type=template&id=0856f961&scoped=true&lang=html&"
import script from "./pkg.vue?vue&type=script&lang=js&"
export * from "./pkg.vue?vue&type=script&lang=js&"
import style0 from "./pkg.vue?vue&type=style&index=0&id=0856f961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856f961",
  null
  
)

component.options.__file = "pkg.vue"
export default component.exports